import React, { useEffect, useState } from "react";
import {
  BackButton,
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { useFormik } from "formik";
import * as yup from "yup";
import { NuInput, NuMobileNumber } from "../../../../Components/Utils/Input";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import axiosInstance from "../../../../Services/axiosCommon";
import UseCustomerDropDownNew from "../../../../Components/Hooks/useCustomerSearch";
import { SettingHeading } from "../../../../Components/Utils/Settingheading";
import CustomImgUpload from "../../../../Components/Utils/CustomImgUpload";
import useAddFormData from "../../../../Components/Hooks/useAddFormData";

function CreateUser() {
  const { Oncancel, addFormData, contextHolder, isLoading } = useAddFormData();
  const [image, setImage] = useState([]);
  const [roleList, setRoleList] = useState([]);
  const [createNew, setCreateNew] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
    userId: "",
    userType: "0",
    roleId: "",
    clientId: "",
  });
  const [searchClient, setSearchClient] = useState("");
  const [clientUrl, setClientUrl] = useState("");
  const [contractorUrl, setContractorUrl] = useState("");

  // Formik setup
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false, // Validate only on submit
    validateOnBlur: false, // Validate only on submit
    validationSchema: yup.object({
      email: yup.string().email("Invalid email format").required("Email is required!"),
      roleId: yup.string().required("Role is required!"),
      clientId: yup.string().when("userType", {
        is: (userType) => ["1", "2", "3"].includes(userType),
        then: () => yup.string().required("This field is required!"),
        otherwise: () => yup.string().notRequired(),
      }),
      name: yup.string().when("userType", {
        is: "0",
        then: () => yup.string().required("Name is required!"),
        otherwise: () => yup.string().notRequired(),
      }),
    }),
    onSubmit: async (values, { resetForm }) => {
      console.log("Form Values on Submit:", values); // Debug log
      let formData = new FormData();
      let isClient = values.userType === "1";
      let newValue = { ...values, isClient };
      formData.append("json_data", JSON.stringify(newValue));
      if (image.raw) {
        formData.append("userImage", image.raw);
      }
      await addFormData({
        url: `/user/create-user`,
        formData: formData,
        navigateUrl: `/settings/user`,
        resetForm: resetForm,
      });
    },
  });

  // Update client and contractor URLs based on userType
  useEffect(() => {
    if (formik.values.userType === "1") {
      setClientUrl("/clients/drop-down");
      setContractorUrl("");
    } else if (formik.values.userType === "3") {
      setContractorUrl("/suppliers/drop-down/2");
      setClientUrl("");
    } else {
      setClientUrl("");
      setContractorUrl("");
    }
  }, [formik.values.userType]);

  const { data: client } = UseCustomerDropDownNew(clientUrl, searchClient);
  const { data: contractor } = UseCustomerDropDownNew(contractorUrl, searchClient);

  // Fetch roles
  function GetRoles() {
    axiosInstance
      .get("/role/")
      .then((res) => {
        const arr = res?.data?.data?.map((item) => ({
          value: item?.roleId,
          label: item?.roleName,
        })) || [];
        setRoleList(arr);
      })
      .catch((err) => {
        console.error("Error fetching roles:", err);
      });
  }

  useEffect(() => {
    GetRoles();
  }, []);

  // Auto-set roleId for Client userType
  useEffect(() => {
    if (formik.values.userType === "1") {
      const clientRole = roleList.find((role) => role.label === "Client");
      if (clientRole) {
        formik.setFieldValue("roleId", clientRole.value);
      }
    } else {
      formik.setFieldValue("roleId", "");
    }
  }, [formik.values.userType, roleList]);

  // Fetch team data for userType "2"
  const [Newinspector, setInspector] = useState([]);

  function getContractsByClientId() {
    axiosInstance
      .get(`/team/drop-down`)
      .then((res) => {
        if (Array.isArray(res.data)) {
          const formatted = res.data.map((item) => ({
            value: item.value,
            label: item.label,
          }));
          setInspector(formatted);
        } else {
          console.error("Unexpected API response format");
          setInspector([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching team data:", err);
        setInspector([]);
      });
  }

  useEffect(() => {
    if (formik.values.userType === "2") {
      getContractsByClientId();
    } else {
      setInspector([]); // Clear team data for other user types
    }
  }, [formik.values.userType]);
const [inputKey, setInputKey] = useState(Date.now()); 

 const handleChangeImg = (e) => {
    if (e.target.files.length) {
        setImage({
            preview: URL.createObjectURL(e.target.files[0]),
            raw: e.target.files[0],
        });
    }
};

const handleImageRemove = () => {
    setImage(
      { preview: "", raw: "" }
    );
    setInputKey(Date.now()); 
};

  const handleDeleteImg = () => {
    setImage({ preview: "", raw: "" });
    setCreateNew((prev) => ({ ...prev, userImage: "" }));
    formik.setFieldValue("userImage", "");
  };

  return (
    <div className="w-full h-full px-4 py-2">
      {contextHolder}
      <div className="w-full sm:flex justify-between items-center">
        <Breadcrumb
          items={[
            { name: "Settings" },
            { name: "User", link: "/settings/user" },
            { name: "Create" },
          ]}
        />
        <div className="flex justify-end">
          <BackButton />
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="w-full mx-auto h-[calc(100vh-145px)] bg-white rounded-xl overflow-hidden mt-4">
          <div className="w-full h-full flex justify-start content-start flex-wrap py-2 px-4 overflow-y-auto">
            <div className="w-full">
              <SettingHeading title="Personal Info" />
            </div>
               <CustomImgUpload
              label="User Profile"
                                     key={inputKey}
                                        borderStyle="dashed"
                                        isRemove={true}
                                        width='w-full'
                                        removeFunction={handleImageRemove}
                                        handleChange={handleChangeImg}
                                        preview={image.preview || createNew.userImage || ""}

                                    />
          
            <FormikSelectTwo
              type="text"
              label="Type"
              placeholder="Choose"
              Options={[
                { value: "0", label: "User" },
                { value: "1", label: "Client" },
                { value: "2", label: "Team" },
                { value: "3", label: "Sub-Contractor" },
              ]}
              formik={formik}
              name="userType"
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
              PortalTarget={false}
            />
            {formik.values.userType === "0" && (
              <NuInput
                type="text"
                label="Name"
                placeholder="Enter Name"
                formik={formik}
                name="name"
                isRequired={true}
                width="w-full md:w-1/3 md:-mt-2"
              />
            )}
            {formik.values.userType === "1" && (
              <div className="w-full md:w-1/3 md:-mt-2">
                <FormikSelectTwo
                  label="Client"
                  placeholder="Client"
                  Options={client}
                  formik={formik}
                  name="clientId"
                  isRequired={true}
                  setSearch={setSearchClient}
                  onChange={(selectedOption) => {
                    formik.setFieldValue("clientId", selectedOption?.value || "");
                    formik.setFieldValue("name", selectedOption?.label || "");
                  }}
                />
            
              </div>
            )}
            {formik.values.userType === "2" && (
              <div className="w-full md:w-1/3 md:-mt-2">
                <FormikSelectTwo
                  label="Team"
                  placeholder="Team"
                  Options={Newinspector}
                  formik={formik}
                  name="clientId"
                  isRequired={true}
                  onChange={(selectedOption) => {
                    formik.setFieldValue("clientId", selectedOption?.value || "");
                    formik.setFieldValue("name", selectedOption?.label || "");
                  }}
                />
              
              </div>
            )}
            {formik.values.userType === "3" && (
              <div className="w-full md:w-1/3 md:-mt-2">
                <FormikSelectTwo
                  label="Sub-Contractor"
                  placeholder="Sub-Contractor"
                  Options={contractor}
                  formik={formik}
                  name="clientId"
                  isRequired={true}
                  onChange={(selectedOption) => {
                    formik.setFieldValue("clientId", selectedOption?.value || "");
                    formik.setFieldValue("name", selectedOption?.label || "");
                  }}
                />
               
              </div>
            )}
            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuMobileNumber
              nunCode="countryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="phone"
              width="w-full md:w-1/3 md:-mt-2"
              FixPosition={true}
              PortalTarget={false}
            />
            <div className="w-full">
              <SettingHeading title="User Role" />
            </div>
            <FormikSelectTwo
              type="text"
              label="Role"
              placeholder="Choose"
              Options={roleList}
              formik={formik}
              name="roleId"
              width="w-full md:w-1/3 md:-mt-2"
              isRequired={true}
            />
            <div className="w-full mx-auto my-4 mt-8">
              <div className="flex justify-end gap-4">
                <CancelButton
                  handleClick={() => {
                    Oncancel(-1);
                  }}
                />
                <SubmitButton isLoading={isLoading} />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default CreateUser;